;(function () {
  /* TODO looks like this directive is never used, if that's the case we should remove this file and all its references */
  angular
    .module('contrast.vulnerabilities')
    .controller('csVulnerabilityTraceCtrl', csVulnerabilityTraceCtrl)

  function csVulnerabilityTraceCtrl(
    $filter,
    VulnerabilitiesService,
    permissions
  ) {
    'ngInject'

    var vm
    this.$onInit = function () {
      vm = this
    }

    angular.extend(vm, {
      tooltipTplLicensed: 'views/tooltips/vulnerability/vulnTitleTooltip.html',
      tooltipTplNoLicense: 'views/tooltips/licenseVulnTooltip.html'
    })

    angular.extend(vm, {
      activate: activate,
      getTraceTitle: getTraceTitle,
      isVisible: isVisible,
      hasViolations: hasViolations,
      getEnvironments: getEnvironments,
      getMostPermissiveRole: getMostPermissiveRole
    })

    function activate(params) {
      vm = angular.extend(vm, params)
    }

    function getTraceTitle() {
      return $filter('searchfilter')(vm.trace.title, vm.model.searchKeywords())
    }

    function isVisible() {
      return vm.trace.visible
    }

    function hasViolations() {
      return vm.trace.violations.length > 0
    }

    function getEnvironments() {
      return VulnerabilitiesService.getTraceEnvironments(vm.trace.environments)
    }

    function getMostPermissiveRole() {
      return permissions.getMostPermissiveRole()
    }
  }
})()
